import { isDisabled } from "@testing-library/user-event/dist/utils";
import { Col, Select } from "antd";
import { Input } from "antd";
import { Radio } from "antd";
import { Form } from "antd";
import { Row } from "antd";
import React, { FC } from "react";

type MedicalInformationProps = {
  isDisabled?: boolean;
};

const { Option } = Select;

const MedicalInformation: FC<MedicalInformationProps> = ({ isDisabled }) => {
  const allergies = Form.useWatch("allergies");
  const habitsAddictions = Form.useWatch("habitsAddictions");

  return (
    <>
      <h2>Medical Information</h2>

      <h3 style={{ margin: "14px 0" }}>GENERAL FINDING</h3>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="TEMPERATURE (°F)"
            name="temperature"
            rules={[
              { required: true, message: "Please enter temperature" },
              {
                pattern: /^[0-9.]+$/,
                message: "Please enter numeric values only",
              },
            ]}
          >
            <Input placeholder="Enter Temperature" disabled={isDisabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="PULSE RATE PER MINUTE"
            name="pulseRatePerMinute"
            rules={[
              { required: true, message: "Please enter pulse rate" },
              {
                pattern: /^[0-9.]+$/,
                message: "Please enter numeric values only",
              },
            ]}
          >
            <Input
              placeholder="Enter pulseRatePerMinute"
              disabled={isDisabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="HEIGHT (CM)"
            name="height"
            rules={[
              { required: true, message: "Please enter height" },
              {
                pattern: /^[0-9.]+$/,
                message: "Please enter numeric values only",
              },
            ]}
          >
            <Input placeholder="Enter height(cm)" disabled={isDisabled} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="WEIGHT (KG)"
            name="weight"
            rules={[
              {
                pattern: /^[0-9.]+$/,
                message: "Please enter numeric values only",
              },
            ]}
          >
            <Input placeholder="Enter weight(kg)" disabled={isDisabled} />
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item label="CYANOSIS" name="cyanosis">
            <Radio.Group disabled={isDisabled}>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item label="PALLOR" name="pallor">
            <Radio.Group disabled={isDisabled}>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item label="MALNUTRITION" name="malnutrition">
            <Radio.Group disabled={isDisabled}>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item label="OEDEMA In FEET" name="oedema">
            <Radio.Group disabled={isDisabled}>
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col> */}
      </Row>

      {/* <h3 style={{ margin: "14px 0" }}>FAMILY FINDING</h3>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="DIABETES"
            name="diabetes"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            label="HYPERTENSION"
            name="hypertension"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="heartDisease"
            label="Heart Disease"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="stroke"
            label="Stroke"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="cancer"
            label="Cancer"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="tuberculosis"
            label="Tuberculosis"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="asthma"
            label="Asthma"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Option value="None">None</Option>
              <Option value="Self">Self</Option>
              <Option value="Family">Family</Option>
              <Option value="Both">Both Self and Family</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row> */}

      <h3 style={{ margin: "14px 0" }}>PERSONAL HISTORY</h3>
      <Row gutter={[16, 16]}>
        {/* <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="diet"
            label="Diet"
            rules={[{ required: true, message: "Please select diet type" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Select.Option value="Normal">Normal</Select.Option>
              <Select.Option value="Special">Special</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="nutrition"
            label="Nutrition"
            rules={[
              { required: true, message: "Please select nutrition type" },
            ]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Select.Option value="Normal">Normal</Select.Option>
              <Select.Option value="Malnourished">Malnourished</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="appetite"
            label="Appetite"
            rules={[{ required: true, message: "Please select appetite type" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Select.Option value="Normal">Normal</Select.Option>
              <Select.Option value="Low">Low</Select.Option>
              <Select.Option value="Excessive">Excessive</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="bowels"
            label="Bowels"
            rules={[{ required: true, message: "Please select bowels type" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Select.Option value="Normal">Normal</Select.Option>
              <Select.Option value="Constipation">Constipation</Select.Option>
              <Select.Option value="Loose">Loose</Select.Option>
            </Select>
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="allergies"
            label="Known Allergies"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group
              disabled={
                isDisabled
              }
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        {/* {
          allergies === "Yes" ? <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="allergyDetails"
            label=" Allergy Details"
            rules={[{ required: true, message: "Allergy Details is Required!" }]}
          >
            <Input placeholder="Enter Allergy Details" disabled={isDisabled} />
          </Form.Item>
        </Col> : null
        } */}
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Form.Item
            name="habitsAddictions"
            label="Habits Addictions"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group
              disabled={
                isDisabled
              }
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        {/* {
          habitsAddictions === "Yes" ? <Col xs={24} sm={12} md={5} lg={5} xl={5}>
          <Form.Item
            name="habitsAddictionsDetails"
            label="Habits Addictions Details"
            rules={[{ required: true, message: "Habits Addictions Details is Required!" }]}
          >
            <Select
              placeholder="Select"
              disabled={
                isDisabled
              }
            >
              <Select.Option value="Alcohol">Alcohol</Select.Option>
              <Select.Option value="Smoking">Smoking</Select.Option>
              <Select.Option value="Drugs">Drugs</Select.Option>
              <Select.Option value="Others">Others</Select.Option>
            </Select>
          </Form.Item>
        </Col> : null
        } */}
      </Row>
    </>
  );
};

export default MedicalInformation;